import * as React from "react";
import { SVGProps } from "react";
const SvgLogoMerge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={17}
    height={17}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#logo-merge_svg__a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 2.5h8v2h-4a2 2 0 0 0-2 2v4h-2v-8Zm2 10h-2a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-2Zm8-6h2v8h-8v-2h4a2 2 0 0 0 2-2v-4Zm-2 0v4h-4v-4h4Z"
        fill="#3A86FF"
      />
    </g>
    <defs>
      <clipPath id="logo-merge_svg__a">
        <path fill="#fff" transform="translate(.5 .5)" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoMerge;
